import React, { useState, useEffect, useRef } from "react"
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll"
import { Splide } from "@splidejs/splide"
import { useMediaQuery } from "react-responsive"
import Request from "../../helpers/Request"

const BusinessCourierBrand = () => {
  const isLargeScreen = useMediaQuery({ query: "(min-width: 992px)" })
  const isMediumScreen = useMediaQuery({ query: "(min-width: 778px)" })
  const isSmallScreen = useMediaQuery({ query: "(min-width: 576px)" })
  const [courierLinks, setCourierLinks] = useState([])
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    Request("/business_courier_brand.json", "GET").then((response) => {
      if (response.active) {
        setCourierLinks(response.data)
        setLoaded(true)
        console.log("BusinessCourierBrand is active")
      } else {
        console.log("BusinessCourierBrand is not active")
      }
    });
  }, []);

  useEffect(() => {
    if (!courierLinks) return
    if (!loaded) return
    new Splide(".splide", {
      type: "loop",
      drag: "free",
      focus: "center",
      arrows: false,
      pagination: false,
      perPage: isMediumScreen ? 6 : 2,
      autoScroll: {
        speed: 1,
      },
    }).mount({ AutoScroll })
  }, [courierLinks, loaded])

  return (
    <>
      {courierLinks && (
        <div className="splide">
          <div className="splide__track">
            <ul className="splide__list">
              {courierLinks.map((link) => (
                <li className="splide__slide" key={link.alt}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                    }}
                  >
                    <a href={`${link.url}`} target="_blank">
                      <img
                        src={`${link.image_url}`}
                        style={{ maxHeight: 60, maxWidth: "80%" }}
                      />
                    </a>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div >
      )}
    </>
  )
}

export default BusinessCourierBrand
